export const IconCardId = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.1666 17.5H5.83329C2.49996 17.5 1.66663 16.6667 1.66663 13.3333V6.66667C1.66663 3.33333 2.49996 2.5 5.83329 2.5H14.1666C17.5 2.5 18.3333 3.33333 18.3333 6.66667V13.3333C18.3333 16.6667 17.5 17.5 14.1666 17.5Z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.6666 6.6665H15.8333"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 10H15.8333"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.1666 13.3335H15.8333"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.08328 9.40827C7.91631 9.40827 8.59162 8.73296 8.59162 7.89993C8.59162 7.0669 7.91631 6.3916 7.08328 6.3916C6.25025 6.3916 5.57495 7.0669 5.57495 7.89993C5.57495 8.73296 6.25025 9.40827 7.08328 9.40827Z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.99996 13.6085C9.88329 12.4001 8.92496 11.4501 7.71663 11.3418C7.29996 11.3001 6.87496 11.3001 6.44996 11.3418C5.24163 11.4585 4.28329 12.4001 4.16663 13.6085"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
